import React, {lazy, Suspense} from 'react';
import { PageLoading } from '../../../Loading';
import CommonFieldWrapper from '../CommonFieldWrapper';
const TheWysiwyg = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./TheWysiwyg'));

const Wysiwyg = (params) => {
    const fallback = <CommonFieldWrapper {...{padding: 'px-1 py-1.5', ...params}}>
        <PageLoading short />
    </CommonFieldWrapper>;

    return <Suspense fallback={fallback}>
        <TheWysiwyg {...params} />
    </Suspense>
}

export default Wysiwyg;
